<template>
    <div class="sku">
        <h2>SKU-Search</h2>
        <div>{{ connmsg }}</div><br>
        <div class="mui-textfield">
            <input type="text" v-model="filter" placeholder="Filter by SKU">
        </div>
        <table class="mui-table mui-table--bordered">
            <thead>
                <tr>
                    <th>SKU</th>
                    <th>Qty</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="product in filteredItems" :key="product.sku">
                    <td>{{ product.sku }}</td>
                    <td>{{ product.qty }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import router from "@/router"
import store from "@/store"

export default {
  name: "sku",
  data() {
    return {
      filter: "",
      products: [],
      connmsg: ""
    };
  },
  beforeCreate() {
    if (!store.state.isLogged) {
      router.push("/")
    }
  },
  created() {
    this.getProducts()
  },
  methods: {
    getProducts() {
      this.axios.get("getsku").then(
        response => {
          this.products = response.data
        },
        () => {
          this.connmsg = "Error: Could not reach server!"
        }
      )
    }
  },
  computed: {
    filteredItems() {
      var self = this  
      return self.products.filter(function (product) {
        return product.sku.toLowerCase().indexOf(self.filter.toLowerCase()) > -1
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// Sku.vue?28db6f1c